module.exports = __webpack_public_path__ + "img/bgi4.37657abf.png";